__turbopack_context__.v({
  "coloredLine": "PridePanel-module__Rx-4yq__coloredLine",
  "container": "PridePanel-module__Rx-4yq__container",
});
